import styled from 'styled-components';
import { connect } from '@ardoq/rxbeach';
import { PolarView } from './PolarView';
import { polarViewModel$ } from './polarViewModel$';

const ViewRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const ConnectedPolarView = connect(PolarView, polarViewModel$);

export const PolarViewController = () => (
  <ViewRoot className="prevent-context-change">
    <ConnectedPolarView />
  </ViewRoot>
);
